"use strict";
import {on, findIn, findAllIn, setAttribute, removeAttribute, addClass, hasClass, removeClass, find} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import axios from "axios";
import Modal from 'bootstrap/js/dist/modal';
import {createAjaxForm} from "@elements/ajax-form";
import * as formValidation from '@elements/form-validation';
import asyncAppend from "@elements/async-append";

export function init() {

    onFind('.js-account-item', container => {
        let newUserBtn = findIn('.js-account-item__new', container);
        let modal = findIn('.js-account-item__modal', container);

        let userForm = findIn('.js-user-form', container);
        let userFormSubmit = findIn('.js-user-form__submit', container);

        let myModal = Modal.getOrCreateInstance(modal);

        if (userForm) {
            let formApi = createAjaxForm(userForm, undefined, {
                result: '.js-user-form__result',
                loading: '.js-user-form__loading',
                notifications: '.js-alert-notification',
                form: '.js-user-form__form',
                errorArea: '.js-user-form__error-area',
                retry: '.js-user-form__retry',
            });

            on('click', (e) => {
                let formData = formApi.getFormData();

                formValidation.getApi(findIn('.js-user-form__form', userForm)).then((formValidationApi) => {
                    let formInstance = formValidationApi.getFormInstance();

                    formInstance.validate().then((state) => {
                        if (state === 'Valid') {
                            //check if result already has element inside and append it to lower list
                            let result = findIn('.js-user-form__result', userForm);
                            let list = findIn('.js-user-form__list', userForm);
                            if(result.childNodes.length !== 0){
                                Array.prototype.slice.call(result.childNodes).map(node => {
                                    list.prepend(node);
                                    result.innerHTML = '';
                                });
                            }

                            //when item gets edited, remove existing one from list to prevent double elements
                            if(formData.get('id')){
                                findAllIn('.js-account-item__item', userForm).map((item) => {
                                    let data = JSON.parse(item.getAttribute('data-account-item-data'));

                                    if(data.id.toString() === formData.get('id').toString()) {
                                        item.remove();
                                    }
                                });
                            }

                            formApi.submit();
                        }
                    });
                });
            }, userFormSubmit);

            on('submit.ajax-form', (evt) => {
                myModal.hide();
            }, userForm);

            on('show.bs.modal', (e) => {
                formValidation.getApi(findIn('.js-user-form__form', userForm)).then((formApi) => {
                    let formInstance = formApi.getFormInstance();
                    formInstance.resetForm(true);
                });
            }, modal);
        }

        let modalForm = findIn('.js-account-item__modal-form', modal);
        if (findIn('.js-account-item__modal-form', modal)) {
            on('form-validation.submit', (evt) => {
                let pendingRequest = axios({method: 'POST', url: modalForm.getAttribute('data-action'), data: new FormData(modalForm) });

                asyncAppend({
                    target: findAllIn('.js-account-form__result', container),
                    loading: findAllIn('.js-account-form__loading', container)
                }, pendingRequest.then((x) => {
                    myModal.hide();

                    return x.data;
                }))
            }, modalForm);
        }

        on('click', (evt) => {
            findAllIn('.js-account-item__hidden', modal).forEach( item => {
                removeClass('d-none', item);
            });
            if(evt.target.getAttribute('data-modal-title')){
                findIn('.js-account-item__modal-title', modal).innerHTML = evt.target.getAttribute('data-modal-title');
            }
            clearFields(modal);
            if(findIn('.js-account-item__role-allowed', modal)){
                findIn('.js-account-item__role-allowed', modal).checked = true;
            }
        }, newUserBtn);

        // findAllIn('.js-account-item__item', container).map((parent) => {
        // })

        // });
    });

    onFind('.js-account-item__item', parent => {
        let editBtn = findIn('.js-account-item__edit', parent);
        let deleteBtn = findIn('.js-account-item__delete', parent);

        //load existing data in editing modal
        on('click', (evt) => {
            let modal = find(editBtn.getAttribute('data-bs-target'));
            let data = JSON.parse(parent.getAttribute('data-account-item-data'));
            let rolesUrl = parent.getAttribute('data-account-item-roles') + 'userid=' + data.id;

            clearFields(modal);

            if (evt.target.getAttribute('data-modal-title')) {
                findIn('.js-account-item__modal-title', modal).innerHTML = evt.target.getAttribute('data-modal-title');
            }

            findAllIn('.js-account-item__hidden', modal).forEach(item => {
                addClass('d-none', item);
                findIn('input', item).removeAttribute('required');
            });

            //set inputs from json in data attribute
            for (const [key, value] of Object.entries(data)) {
                findAllIn('input', modal).forEach(input => {
                    if (input.getAttribute('name') === key) {
                        input.value = value;
                    }
                });
                findAllIn('select', modal).forEach(select => {
                    if (select.getAttribute('name') === key) {
                        findAllIn('option', select).forEach(option => {
                            if (option.getAttribute('value') === value) {
                                setAttribute('selected', true, option);
                            }
                        });
                    }
                });
            }

            //get and set Roles in checkboxes
            let pendingRequest = axios({method: 'POST', url: rolesUrl});
            let loading = findIn('.js-account-item__modal-loading', modal);

            removeAttribute('hidden', loading);

            pendingRequest.then((response) => {
                let foundedRoles = [];
                findAllIn('.js-account-item__role-checkbox', modal).forEach(checkbox => {
                    foundedRoles = [...foundedRoles, ...checkbox.getAttribute('data-rights').split(',')];

                    checkbox.checked = false;

                    let rights = checkbox.getAttribute('data-rights').split(',');
                    let foundAll = true;

                    rights.forEach(right => {
                        if (typeof right == 'string') {
                            let found = false;
                            response.data.roles.forEach(role => {
                                if (role.name === right) {
                                    found = true;
                                }
                            });
                            if (!found) {
                                foundAll = false;
                            }
                        }
                    });

                    if (foundAll) {
                        checkbox.checked = true;
                    }
                });

                let missingRoles = [];
                response.data.roles.forEach(role => {
                    if (!foundedRoles.includes(role.name)) {
                        missingRoles.push(role.name);
                    }
                });

                if (findIn('.js-account-item__role-input', modal)) {
                    findIn('.js-account-item__role-input', modal).value = missingRoles;
                }

                setAttribute('hidden', 'true', loading);

            }).catch(e => {
                console.warn(e);
            });

        }, editBtn);

        //copy delete link into delete-modal
        on('click', (evt) => {
            let link = deleteBtn.getAttribute('data-account-item-delete');
            let deleteLink = findIn('.js-account-item__delete-link', find(deleteBtn.getAttribute('data-bs-target')));
            setAttribute('href', link, deleteLink);
        }, deleteBtn);
    });

    function clearFields(modal){
        findAllIn('input', modal).forEach( input => {
            if(!hasClass('js-account-item__role-checkbox', input)){
                input.value = null;
            }
        });
        findAllIn('select', modal).forEach( select => {
            findAllIn('option', select).forEach(option => {
                removeAttribute('selected', option);
            });
        });
        findAllIn('.js-account-item__role-checkbox', modal).forEach(checkbox => {
            checkbox.checked = false;
        });
    }
}